import './config/env-stage-setup'

import { StrictMode } from 'react'
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom'

import App from './App'
import config from './config/app-config'
import reportWebVitals from './reportWebVitals'

const isProduction = __PROD__
const isStaging = __STAGING__

Sentry.init({
  dsn: config?.sentryDSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    ...(isProduction ? [Sentry.replayIntegration()] : []),
  ],
  sampleRate: isProduction ? 1.0 : 0.2,
  tracesSampleRate: isProduction ? 0.5 : 0.1,
  tracePropagationTargets: [
    'https://api.databiologics.com',
    'https://staging-api.databiologics.com',
  ],
  replaysSessionSampleRate: isProduction ? 0.1 : 0,
  replaysOnErrorSampleRate: isProduction ? 1.0 : 0,
  environment: `access-${process.env.REACT_APP_STAGE}`,
  enabled: isProduction || isStaging,
})

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root'),
)

reportWebVitals()
